<template>
  <div v-if="hasCompanies">
    <ModalToggleCompanyStatus
      v-if="pendingToggle"
      :value="true"
      :company="pendingToggle.company"
      :action="pendingToggle.action"
      @input="pendingToggle = null"
      @confirmed="onStatusConfirmed"
    />

    <table class="table table-borderless table-border table-align table-h51">
      <thead>
      <tr>
        <th>Razão Social</th>
        <th>CNPJ</th>
        <th>UF</th>
        <th>Filiais</th>
        <th>Certificado Digital</th>
        <th>E-mail</th>
        <th>Telefone</th>
        <th>Status da Empresa</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="company in companies" :key="company.id">
        <td>{{ company.name | uppercase }}</td>
        <td>{{ company.cnpj | cnpj }}</td>
        <td>{{ company.uf }}</td>
        <td>{{ company.totalSubsidiaries || 0 }}</td>
        <td>
          <strong v-if="checkDate(company.certificateExpiringAt)">
            {{ company.certificateExpiringAt | certificate }}
          </strong>
          <strong v-else style="color: red">
            {{ company.certificateExpiringAt | certificate }}
          </strong>
        </td>
        <td>{{ company.email }}</td>
        <td>{{ company.phone }}</td>
        <td>
          <CompanyStatusToggle :company="company" @request-toggle="pendingToggle = $event"/>
        </td>
        <td class="text-right">
          <button @click="$emit('showCompany', company)" class="btn-icon btn-outline">
            <edit-icon size="1.5x"/>
          </button>
          <button v-if="$withPolicy('application', 'companies/delete')"
                  @click="$emit('sendDeleteCompany', company)"
                  class="btn-icon btn-outline-red ml-2 mr-3">
            <trash-2-icon size="1.5x"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <p class="mt-4">
      {{ getUser.role === 'owner' ? 'Nenhuma empresa cadastrada' : 'Nenhuma empresa cadastrada ou você não possui acesso' }}
    </p>
  </div>

</template>

<script>
  import { Trash2Icon, EditIcon } from 'vue-feather-icons'
  import getUser from '@/mixins/GetUser.vue';
  import CompanyStatusToggle from '@/components/company/CompanyStatusToggle'
  import ModalToggleCompanyStatus from '@/components/company/ModalToggleCompanyStatus'
  import { COMPANY_STATUS } from '@/utils/companyStatus'

  export default {
    components: { CompanyStatusToggle, EditIcon, ModalToggleCompanyStatus, Trash2Icon },
    mixins: [ getUser ],
    data() {
      return {
        pendingToggle: null
      }
    },
    methods: {
      checkDate(string) {
        if (string) {
          const date = new Date(string)
          return date > new Date()
        }
      },
      onStatusConfirmed(company) {
        const entityStatusId = this.pendingToggle && this.pendingToggle.action === 'disable'
          ? COMPANY_STATUS.DISABLED
          : COMPANY_STATUS.ENABLED
        this.$set(company, 'entityStatusId', entityStatusId)
        this.pendingToggle = null
      },
    },
    name: 'Index',
    props: {
      companies: { required: true, type: Array}
    },
    computed: {
      hasCompanies() {
        return this.companies.length > 0
      }
    }
  }
</script>

<style scoped>

</style>
